import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ConnectionPositionPair } from '@angular/cdk/overlay';

import { ChangeDetectorRef, Component, Inject, Input, OnInit, DOCUMENT } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject, Subscription, fromEvent } from 'rxjs';
import { AppModule } from 'src/app/app.module';
import { CardView } from 'src/app/interfaces/cardview';
import { UserPreference } from 'src/app/interfaces/user-preference';
import { HTTPService } from 'src/app/services/http.service';
import { PermissionServices } from 'src/app/services/permission.services';
import { ThemeService } from 'src/app/services/theme.service';
import { UserAuthenticationServices } from 'src/app/services/user-authentication.services';
import { UserConfigServices } from 'src/app/services/user-config.services';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';
import { SystemViewModule } from 'src/app/system-view/system-view.module';

export interface InstanceConfiguration{
  entityName:string;
  titleInstance:string;
  idDashboard:number;
  type:string;
  condition:string;
  iconClass:string;
  nodata:boolean;
  iconName?:string;
  parentRow?:CardView;
  order:number;
  canAccess:Boolean;
  showImageData?:Boolean;
  showImageDataBase64?:Boolean;
  id?:string;
  component?:string;
  properties?:string;
  formulaPropriedade?:string;
}


@Component({
    selector: 'app-instance-generic-view',
    templateUrl: './instance-generic-view.component.html',
    styleUrls: ['./instance-generic-view.component.scss'],
    standalone: false
})

export class InstanceGenericViewComponent implements OnInit {
  userId: number;
  subscription: Subscription;
  subscription1: Subscription;
  isOpen = false;
  controlPressed = false;
  userPreference:UserPreference = null;

  positionPairs: ConnectionPositionPair[] = [
    {
      offsetX: 0,
      offsetY: 0,
      originX: 'center',
      originY: 'top',
      overlayX: 'center',
      overlayY: 'top',
      panelClass: null,
    },
  ];
  idMenu: string = null;
  
  constructor(private ap: PermissionServices, private cd:ChangeDetectorRef,
  private http:HTTPService, private uas:UserAuthenticationServices,
  private ucs:UserConfigServices,
  public ThemeService:ThemeService,
  @Inject(DOCUMENT) private document: Document,
  public route:ActivatedRoute) { }

  /** spinner NG-ZORRO da tela (substitui o ngx-spinner) */
  loading = false;

  eventsSubject: Subject<string> = new Subject<string>();
  parentRow:CardView = {};
  condition:string = '0=0';
  @Input() title:string=null;
  @Input() items:InstanceConfiguration[] = [];
  @Input() realItems:InstanceConfiguration[] = [];
  @Input() savedRealItems:InstanceConfiguration[] = [];

  ngOnInit(): void {

    this.userId = this.uas.user.iduser;
    this.loading = true;
    this.items = this.route.snapshot.data['entities'] as InstanceConfiguration[];
    
    this.idMenu = "dynamic_menu_"+this.route.snapshot.data['idMenu'];
    this.title = this.route.snapshot.data['title']!=null? this.route.snapshot.data['title']: null;
    this.ucs.loadUserPreference(this.userId, this.idMenu).subscribe({
        next:(response)=>{
          if ( response['Mktpuserpref'][0]){
            if ( ObjectUtil.isNotEmpty( response['Mktpuserpref'][0])){
              this.userPreference = response['Mktpuserpref'][0] as UserPreference;
            }
            if ( this.userPreference != null ){
              this.savedRealItems = JSON.parse(this.userPreference.PREFERENCE) as InstanceConfiguration[];
            }
          }

          this.checkPermission();
          this.loading = false;
        },
        error:(error)=>{
          this.loading = false;
          throw error;
        }
    });

     this.subscription = fromEvent<KeyboardEvent>(this.document, 'keydown').subscribe(
      (event: KeyboardEvent) => {
        if (event.ctrlKey) {
          this.controlPressed = true;
        } else {
          this.controlPressed = false;
        }       
      }
    );

    this.subscription1 = fromEvent<KeyboardEvent>(this.document, 'keyup').subscribe(
      (event: KeyboardEvent) => {
        this.controlPressed = false;
      }
    );

  }


  onTabChanged(index: number){
    // consumidores (ex.: main-dashboard) só reagem ao evento; o payload identifica a aba
    this.eventsSubject.next(this.realItems[index] != null ? String(this.realItems[index].entityName) : String(index));
    this.cd.detectChanges();
  }

  checkAccess(entityName:string):Boolean{
    let canAccess:Boolean = false;
    if ( entityName!= null ){
      canAccess = this.ap.checkPermissionSession(entityName,'view');
    }else{
      canAccess = true;
    }
    return canAccess;
  }

  checkPermission(){
    
    this.realItems = this.items.filter(d=>{
      let canAccess = this.checkAccess(d.entityName);
      d.canAccess = canAccess;
      let saved = this.savedRealItems.find(x=>x.entityName == d.entityName );
      if ( saved!= null){
        d.order = saved.order;
      }
        
      return d.canAccess;
    });
    this.sort();
  }

  sort(){
    this.realItems.sort((a,b)=>{
      if ( a.order > b.order ){
        return 1;
      }
      if ( a.order < b.order ){
        return -1;
      }
      return 0;
   });
  }

  onRightClick(event) {
    event.preventDefault();
    this.isOpen=false;
    if (this.controlPressed){
      this.isOpen=true;
    }else{
      this.isOpen=false;
    }
   }


   salvarConfig(){
    return new Promise((resolve, reject) => {

      let jsonSave: Object = {
        entityName: "Mktpuserpref",
        IDPREFERENCE:this.idMenu,
        IDUSER: this.uas.user.iduser,
        PREFERENCE: JSON.stringify(this.realItems)
      };

      this.http.post(jsonSave, "JsonBrokerServices/save", true).subscribe();
      this.controlPressed = false;
      this.isOpen = false;
    });
  }

  drop(event: CdkDragDrop<InstanceConfiguration[]>) {    
    
    this.realItems[event.previousIndex].order = event.currentIndex;
    this.realItems[event.currentIndex].order = event.previousIndex;
    this.sort();
    
    let oldMarketPlace = JSON.parse(JSON.stringify(this.realItems));
    this.realItems = [];
    this.realItems = [...oldMarketPlace];
    
  }
}
